<!DOCTYPE html>
<div class="ot-dataview-row">
  <div [id]="identifier" class="ot-dataview-container">
    @if (title != null) {
      <div class="ot-dataview-header">
        <div class="ot-table">
          <app-dataheaderbar [title]="title" [showtreeicon]="showtreeicon" [showtree]="showtree" [showfiltericon]="showfiltericon" [showfilter]="showfilter"
            [showaddicon]="showaddicon" [showadd]="showadd" [showfavoriteicon]="showfavoriteicon" [showcommenticon]="showcommenticon" [showsettingsicon]="showsettingsicon"
            [showshareicon]="showshareicon" [shareicontitle]="shareicontitle"
            [showdragdrop]="showdragdrop" [showswitchenvicon]="showSwitchEnv" (onclicktree)="onClickHeaderTree()" (onclickfilter)="onClickHeaderFilter()" (onclickadd)="onClickHeaderAdd()"
            (onclickcomment)="onClickHeaderComment()" (onclickfavorite)="onClickHeaderFavorite()" (onclicksettings)="onClickHeaderSettings()"
          (onclickdragdrop)="onClickHeaderDragDrop()" (onclickswitchenv)="onClickSwitchEnv()" (onclickdownload)="onClickDownload()"></app-dataheaderbar>
        </div>
      </div>
    }
    <div class="ot-dataview-body">
      @if (showtree) {
        <div class="ot-dataview-side-panel" [resizable]="isResizable" [ngClass]="{'no-scroll-side-panel' : usetreescroll}">
          @if (!usetreescroll) {
            <ng-scrollbar>
              @if (sidepaneltitle != '') {
                <div id="sidePanelTitle" class="ot-dataview-side-panel-title" [attr.title]="this.sidepaneltitle">
                  <div class="ot-dataview-side-panel-title-text">
                    <span>{{sidepaneltitle}}</span>
                  </div>
                </div>
              }
              <div class="ot-dataview-side-panel-container">
                @if (showtree) {
                  <app-tree [data]="treedata" [sidenav]="treesidenav" (expandevent)="expandTree($event)" (changeevent)="changeTree($event)" [showfilter]="showfilter" [url]="url" [adjustForSidePanelTitle]="sidepaneltitle != ''"></app-tree>
                } @else {
                  @if (isLoading && showtree) {
                    <div class="ot-progress-container ot-pt-3">
                      <div id="ot-spinner-text" class="ot-progress ot-progress--is-spinner ot-progress--is-spinner-has-text">
                        <div class="ot-progress__outer">
                          <div class="ot-progress__meter">
                          </div>
                        </div>
                        <div class="ot-progress__text" i18n>Loading...</div>
                      </div>
                    </div>
                  }
                }
              </div>
            </ng-scrollbar>
          }
          @if (usetreescroll) {
            <div>
              @if (sidepaneltitle != '') {
                <div id="sidePanelTitle" class="ot-dataview-side-panel-title" [attr.title]="this.sidepaneltitle">
                  <div class="ot-dataview-side-panel-title-text">
                    <span>{{sidepaneltitle}}</span>
                  </div>
                </div>
              }
              <div class="ot-dataview-side-panel-container" style="border-bottom: none;">
                @if (!isLoading && showtree) {
                  <app-tree [data]="treedata" [sidenav]="treesidenav" (expandevent)="expandTree($event)"
                  (changeevent)="changeTree($event)" [showfilter]="showfilter" [url]="url" [scroll]="usetreescroll" [adjustForSidePanelTitle]="sidepaneltitle != ''"></app-tree>
                } @else {
                  @if (isLoading && showtree) {
                    <div class="ot-progress-container ot-pt-3">
                      <div id="ot-spinner-text" class="ot-progress ot-progress--is-spinner ot-progress--is-spinner-has-text">
                        <div class="ot-progress__outer">
                          <div class="ot-progress__meter">
                          </div>
                        </div>
                        <div class="ot-progress__text" i18n>Loading...</div>
                      </div>
                    </div>
                  }
                }
              </div>
            </div>
          }
        </div>
      }
      <div class="ot-dataview-table-panel">
        <router-outlet></router-outlet>
      </div>
    </div>
    @if (pagination) {
      <div class="ot-dataview-footer">
        <app-pagination (pageevent)="onPageChange($event)"></app-pagination>
      </div>
    }
  </div>
</div>
